<template>
  <v-snackbar :model-value="true"
              location="top"
              :timeout="-1"
  >
    <div class="text-center">
      <v-progress-circular color="primary"
                           indeterminate
                           class="mr-4"
      />
      <span>{{ $t('common.identity-checking.IdentityCheckingInProgressToast.text') }}</span>
    </div>
  </v-snackbar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IdentityCheckingInProgressToast',
})
</script>

<style scoped lang="scss">
:deep(.v-snackbar__wrapper) {
  background: #FFFFFF;
  color: #000000;
}
</style>
